import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#12100E] px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl bg-[#FAF7F2] p-8 shadow-2xl">
        <Logo />
        <h1 className="mt-8 text-2xl font-bold text-[#1E1A17]">Panel de la agencia</h1>
        <p className="mt-1 text-sm text-[#6E655F]">Accede para ver solicitudes, contactos y pagos.</p>
        <div className="mt-6 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" className="h-11 bg-white" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Contraseña</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className="h-11 bg-white" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="admin-login-button" className="h-11 w-full rounded-full bg-[#E05A47] hover:bg-[#c94a38]">
            {loading ? "Entrando…" : "Entrar"}
          </Button>
        </div>
      </form>
    </div>
  );
}
